import { configureStore } from "@reduxjs/toolkit";

import { api } from "./api";
import {
  amountSlice,
  contentSlice,
  coreSlice,
  couponsSlice,
  errorSlice,
  metaSlice,
  mobileSlice,
  modalSlice,
  tutorialSlice,
  userSlice,
  v3Slice,
} from "./slices";
import {
  commonMiddleware,
  couponsMiddleware,
  listenerMiddleware,
  loggerMiddleware,
  metrikaMiddleware,
  playerMiddleware,
  socketMiddleware,
} from "./middlewares";
import {
  LoggerService,
  MetrikaService,
  PlayerService,
  SocketService,
} from "../services";

export const store = configureStore({
  reducer: {
    amount: amountSlice.reducer,
    api: api.reducer,
    content: contentSlice.reducer,
    core: coreSlice.reducer,
    coupons: couponsSlice.reducer,
    error: errorSlice.reducer,
    meta: metaSlice.reducer,
    mobile: mobileSlice.reducer,
    modal: modalSlice.reducer,
    tutorial: tutorialSlice.reducer,
    user: userSlice.reducer,
    v3: v3Slice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .concat(
        api.middleware,
        socketMiddleware(new SocketService()),
        loggerMiddleware(new LoggerService()),
        metrikaMiddleware(new MetrikaService()),
        playerMiddleware(new PlayerService()),
        commonMiddleware,
        couponsMiddleware
      ),
});
